import React from "react";
import { equity, debt, hybrid } from "../../../../data/mutualFundSeoPage";
import { textGenerator } from "./TextGenerator";
import style from "../mfseo.module.css";

const BasedOnAsset = () => (
  <div>
    <h2>1. MUTUAL FUNDS BASED ON ASSET CLASS</h2>
    <p className={style.greyText}>
      There are three different types based on the asset class- Equity funds,
      debt funds, and hybrid funds
    </p>
    <h3>{equity.heading}</h3>
    {equity.content.map(content => {
      return textGenerator(content);
    })}
    <h3>{debt.heading}</h3>
    {debt.content.map(content => {
      return textGenerator(content);
    })}
    <h3>{hybrid.heading}</h3>
    {hybrid.content.map(content => {
      if (typeof content === "string")
        return <p className={style.greyText}>{content}</p>;
      else
        return content.map(obj => {
          return (
            <p className={style.greyText}>
              <span style={{ fontWeight: "bold " }}> {obj.name}</span>
              {obj.desc}
            </p>
          );
        });
    })}
  </div>
);

export default BasedOnAsset;
